import { EntidadeBase } from 'hay-core-react';
class UsuarioLogModel extends EntidadeBase {
    constructor() {
        super('usuariolog');
    }
}
const instance = new UsuarioLogModel();
export default instance;
